"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A397))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:35.536Z
 * @optimized using svgo:^3.0.2
 */
export const Canada = createSVGIcon(
  <>
    <path fill="#fff" stroke="#757575" d="M1 1H17V13H1z" />
    <path fill="#B64343" d="M1 1H5V13H1z" />
    <path fill="#B64343" d="M13 1H17V13H13z" />
    <path stroke="#757575" d="M1 1H17V13H1z" />
    <path
      d="M8.999 7.494v2.007"
      stroke="#B64343"
      strokeWidth=".5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="m11.5 7.296-.344-.156.236-.867-.781.167-.144-.417-.77.748.274-1.557-.488.24L9 4.5l-.485.953-.485-.239.272 1.557-.77-.748-.142.417-.784-.167.238.867-.343.156 1.136 1.009-.142.584L9 8.389l1.504.5-.142-.584z"
      fill="#B64343"
    />
  </>,
  "Canada",
  (strictLocalize) => ({
    viewBox: "0 0 18 14",
    fill: "none",
    titleAccess: strictLocalize({
      id: "GnVoml",
      defaultMessage: "Canada flag",
      description: { text: "The label for the Canada flag icon" },
    }),
  })
);
